import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "flex items-center gap-2" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

import { ref, watch } from 'vue';
import { IsoCode, ItemSelect, ItemSelectPhone } from '@/models/share.model';
import { getFlagEmojiForCountry } from '@/functions/geo.js';
import Dropdown from 'primevue/dropdown';

type SelectItem = (ItemSelect | ItemSelectPhone) & { prefix?: string; };


export default /*@__PURE__*/_defineComponent({
  __name: 'esSelectCountry',
  props: {
    countries: {},
    selectedData: {},
    showPrefix: { type: Boolean },
    default: { type: Boolean }
  },
  emits: ['changeSelect'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit
const currentCountryId = ref<string>(
  props.default 
    ? props.selectedData?.id || IsoCode.LU 
    : props.selectedData?.id || ''
);


const emitChange = () => {
  const selectedCountry = props.countries.find(c => c.id === currentCountryId.value);
  emits('changeSelect', selectedCountry.id);
};

watch(
  () => props.selectedData,
  (newSelectedData) => {
    if (newSelectedData) {
      currentCountryId.value = newSelectedData.id;
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["row", [props.showPrefix ? 'w-7-5' : 'w-full']])
  }, [
    _createVNode(_unref(Dropdown), {
      modelValue: currentCountryId.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentCountryId).value = $event)),
      options: _ctx.countries,
      optionValue: "id",
      optionLabel: "label",
      onChange: emitChange,
      size: "small",
      class: _normalizeClass([props.showPrefix ? 'w-7-5' : 'w-full'])
    }, {
      value: _withCtx((slotProps) => [
        (slotProps.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (props.showPrefix)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(getFlagEmojiForCountry)(slotProps.value)) + " " + _toDisplayString(_ctx.countries.find(c => c.id === slotProps.value)?.prefix), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(getFlagEmojiForCountry)(slotProps.value)) + " " + _toDisplayString(_ctx.countries.find(c => c.id === slotProps.value)?.label), 1))
            ]))
          : _createCommentVNode("", true)
      ]),
      option: _withCtx((slotProps) => [
        _createElementVNode("div", _hoisted_4, [
          (props.showPrefix)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(getFlagEmojiForCountry)(slotProps.option.id)) + " " + _toDisplayString(slotProps.option.prefix) + " " + _toDisplayString(slotProps.option.label), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(getFlagEmojiForCountry)(slotProps.option.id)) + " " + _toDisplayString(slotProps.option.label), 1))
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "options", "class"])
  ], 2))
}
}

})